<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ item.title }}
      </div>
    </div>
    <div class="item_img">
      <img :src="item.img">
    </div>
    <div class="items_3">
      <div class="item">
        <div class="item_div1">
          <p>
            {{ item.title }}
          </p>
        </div>
        <div class="item_div2">
          <div class="item_min">

 			<p>{{item.day}}{{type.id==3?$t('utils.hour'):$t('utils.day')}}</p>
			<p>{{$t('utils.cycle')}}</p> 
          </div>
          <div class="item_day">
            <p>{{ item.min }}</p>
            <p>{{ $t('search.notFound') }}</p>
          </div>
          <div class="item_rate">

			
			<p>{{ item.rate }}%</p>
			<p>{{ $t('utils.dailyIncome') }}</p>
			
          </div>
        </div>
        <!--<div class="item_div3">
          投资周期<p>{{$t('utils.cycle')}}:{{item.day}}{{type.id==3?$t('utils.hour'):$t('utils.day')}}</p>
          <p><span>{{ type.name }}</span></p>
        </div>--><!--每日返款信息-->
        <!--<div class="item_div4">
          <van-progress :percentage="item.percent" />
        </div>-->
        <div class="item_btn">
          <button
            type="button"
            @click="buy(i)"
          >
            {{ $t('utils.invest') }}
          </button>
        </div>
      </div>
      <div
        class="item_content"
        v-html="item.content"
      />
    </div>
    <van-dialog
      v-model="show_tz" 
      show-cancel-button
      :confirm-button-text="$t('utils.confirm')"
      :cancel-button-text="$t('utils.cancel')"
      @confirm="confirm"
    >
      <div class="items_3">
        <div class="item">
          <div class="item_div1">
            <p>
              {{ item.title }}
            </p>
          </div>
          <div class="item_div2">
            <div class="item_rate">
             <!-- <p>{{ item.rate }}%</p>
              <p>{{ $t('utils.dailyIncome') }}</p> -->
			  <p>{{item.day}}{{type.id==3?$t('utils.hour'):$t('utils.day')}}</p>
			  <p>{{$t('utils.cycle')}}</p>
            </div>
            <div class="item_day">
              <p><!--{{$t('utils.moneyMark')}}-->{{ item.min }}</p>
              <p>{{ $t('search.notFound') }}</p>
              <!-- 投资周期<p>{{item.day}}{{type.id==3?$t('utils.hour'):$t('utils.day')}}</p>
						<p>{{$t('utils.cycle')}}</p> -->
            </div>
            <div class="item_min">
              <p><!--{{$t('utils.moneyMark')}}-->{{ item.max }}</p>
              <p>{{ $t('search.historyEmpty') }}</p>
            </div>
          </div>
        </div>
      </div>
      <van-field
        v-model="number"
        type="number"
        :placeholder="$t('item.inputAmount')"
        @input="input()"
      >
        <template #button>
          <!-- 计算日收益 <van-button>{{$t('index.dailyIncome')}}:{{(item.min*item.rate/100).toFixed(2)}}</van-button> -->
          <van-button>{{ $t('index.totalIncome') }}:{{ countIncome }}</van-button>
        </template>
      </van-field>
    </van-dialog>
  </div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import Vue from 'vue';
	import { Progress,Dialog,Field } from 'vant';
	Vue.use(Progress).use(Dialog).use(Field);
	export default {
		name: "ItemDetail",
		data() {
			return {
				data: {},
				item:[],
				type:[],
				show_tz:false,
				number: "",
				countIncome:0
			};
		},
		created() {
			this.$parent.footer('item', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/index/item_detail', {
					id: this.$router.history.current.params.code
				}).then(res => {
					this.item = res.data.item;
					this.type = res.data.type;
					this.number=res.data.money;
				})
			},
			input(){
			 
				this.countIncome = parseFloat((this.number*100/100).toFixed(2)) + parseFloat((this.number*this.item.rate*this.item.day/100).toFixed(2));
			},
			buy(item){
				//this.number = "";
				this.input();
				this.show_tz = true;
			},
			confirm(){
				if(!this.number){
					this.$toast(this.$t('item.inputAmount'));
					return false;
				}
				Fetch("/index/item_apply", {
				  id: this.item.id,
				  money:this.number
				}).then(r => {
				  this.$router.push("/order");
				}).catch(err=>{
				    this.number = '';
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .van-cell{
		padding: 15px 26px;
	}
	.red_top_bg {
		position: fixed;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
	}

	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}

	.big_tit {
		left: 40px;
		width: 90%;
		color: #fff;
		transform: none;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.item_img{
		margin: 45px 2% 0 2%;
		width: 96%;
		img{
			width: 100%;
		}
	}
	.items_3 {
		margin: 5px 2% 0 2%;
		width: 96%;

		.item {
		    background: #0e298d;
		    margin-bottom: 10px;
		    color: #fff;

			div {
				margin: 5px 0;
			}

			.item_div1 {
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid #ECECEC;
				padding: 15px 10px;

				p:nth-child(1) {
					// width: 90%;
					font-weight: bold;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_div2 {
				display: flex;
				justify-content: space-between;
				text-align: center;
				font-size: 14px;

				div {
					width: 33.33%;

					p {
						padding: 5px 0;
					}
				}

				.item_rate {
					p:nth-child(1) {
						font-weight: bold;
						color: #FF0000;

					}

					p:nth-child(2) {
						color: #999;
					}
				}

				.item_day {
					p:nth-child(1) {
						font-weight: bold;
					}

					p:nth-child(2) {
						color: #999;
					}
				}

				.item_min {
					p:nth-child(1) {
						font-weight: bold;

					}

					p:nth-child(2) {
						color: #999;
					}
				}
			}

			.item_div3 {
				color: #999;
				padding: 5px 10px;
			}
					p {
						padding: 5px 0;
					}
			.item_div4 {
				padding: 5px 10px;

				div:nth-child(1) {
					width: 100%;
					margin-top: 16px;
					margin-bottom: 10px;
				}
			}
			.item_btn {
				width: 70%;
				position: absolute;
				bottom: 20px;
				margin-left: 15%;
			
				button {
					width: 100%;
					color: #1989fa;
					padding: 10px 5px;
					border-radius: 5px;
					border: 1px solid #1989fa;
					background: #FFFFFF;
				}
			}
		}
		.item_content{
			background: #0e298d;
			    padding: 10px;
			    line-height: 20px;
			    color: #fff;
		}
	}
	/deep/ .van-field__button{
		color: #999;
	}
</style>
